import {register} from '../vendor/theme-scripts/theme-sections';
import accordions from '../features/accordion';
import {slider} from '../features/slider';

register('reviews', [accordions, slider]);
